// extracted by mini-css-extract-plugin
export default {"supBox":"p37onVKBBq80iBFkyaX2"};